import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { MASCOT } from "@/lib/games";

export default function LoginPage() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("admin@neurokids.com");
  const [password, setPassword] = useState("admin123");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch {
      /* handled */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="clinic-mode min-h-screen flex">
      <div className="hidden lg:flex flex-1 items-center justify-center bg-gradient-to-br from-sky-100 via-sky-50 to-amber-50 p-12">
        <div className="max-w-md text-center">
          <img src={MASCOT} alt="Mundo NeuroKids mascot" className="w-64 h-64 object-contain mx-auto float-soft" />
          <h1 className="text-4xl mt-6 font-bold">Mundo NeuroKids</h1>
          <p className="text-slate-600 mt-3 leading-relaxed">
            Plataforma gamificada para avaliação neuropsicológica infantil.
            Acompanhe o desempenho cognitivo com jogos lúdicos e relatórios clínicos.
          </p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-sm space-y-5"
          data-testid="login-form"
        >
          <div>
            <h2 className="text-3xl font-semibold">Entrar</h2>
            <p className="text-sm text-slate-500 mt-1">Acesso para responsáveis e profissionais.</p>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">E-mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Senha</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <p className="text-sm text-red-600" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 rounded-lg transition disabled:opacity-60"
            data-testid="login-submit-button"
          >
            {busy ? "Entrando…" : "Entrar"}
          </button>
          <p className="text-sm text-center text-slate-500">
            Ainda não tem conta?{" "}
            <Link className="text-sky-600 font-medium" to="/register" data-testid="login-register-link">
              Criar conta
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
